import { render, staticRenderFns } from "./PoliticaDePrivacidadePartiuApp.vue?vue&type=template&id=770ea529&"
import script from "./PoliticaDePrivacidadePartiuApp.vue?vue&type=script&lang=js&"
export * from "./PoliticaDePrivacidadePartiuApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports